/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var Ladda = require('ladda');
var Radio = require('backbone.radio');

var BreadcrumbView = require('common/views/BreadcrumbView');

var CorpFinRecordHeaderBarView = require('./CorpFinRecordHeaderBarView');
var CorpFinSalesCompensationFormView = require('./CorpFinSalesCompensationFormView');

var tmplCorpFinSalesCompensationEditView = require('../templates/CorpFinSalesCompensationEditView.hbs');
var UpdateRecordsSalesCompensation = require('../services/UpdateRecordsSalesCompensation');

module.exports = Marionette.LayoutView.extend({
  template: tmplCorpFinSalesCompensationEditView,

  className: 'corp-fin--sales-comp-edit-view container-fluid',

  ui: {
    salesCompForm: '.sales-comp-form-container',
    headerBar: '.header-bar',
    breadcrumb: '.breadcrumb-container',
    submit: '.submit'
  },

  regions: {
    salesCompForm: '@ui.salesCompForm',
    headerBar: '@ui.headerBar',
    breadcrumb: '@ui.breadcrumb'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    var record = this.model.get('record') || {};
    var recordId = this.model.get('recordId');
    var fileNumber = record.fileNumber;
    var salesCompensation = this.model.get('salesCompensation');

    this.showChildView(
      'headerBar',
      new CorpFinRecordHeaderBarView({
        model: new Backbone.Model(record)
      })
    );

    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#corpfin/dashboard',
            text: 'Home'
          },
          {
            link: '#corpfin/exemption/' + recordId + '/dashboard',
            text: 'Exemption (' + fileNumber + ')'
          },
          {
            text: 'Edit Sales Compensation'
          }
        ]
      })
    );

    this.salesCompForm = new CorpFinSalesCompensationFormView({
      model: new Backbone.Model({ salesCompensation: salesCompensation })
    });

    this.showChildView('salesCompForm', this.salesCompForm);
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var self = this;
    var recordId = self.model.get('recordId');
    var salesCompensation = self.model.get('salesCompensation');
    this.validate().done(
      function() {
        var laddaContext = Ladda.create(this.ui.submit.get(0));
        laddaContext.start();
        var formData = this.getFormData();
        formData.recordID = recordId;
        formData.id = salesCompensation.id;
        UpdateRecordsSalesCompensation(formData)
          .done(function() {
            Radio.channel('navigate').trigger('show:int:cf:exemption-dashboard', self.model.get('recordId'));
          })
          .fail(function() {
            laddaContext.stop();
          });
      }.bind(this)
    );
  },

  validate: function() {
    return this.ui.salesCompForm.parsley().whenValidate();
  },

  getFormData: function() {
    var formData = this.salesCompForm.getFormData();
    return formData;
  }
});
